/*
*###############################################################################
*Module Name                   : DPInfoBox.js                                  #
*Purpose of the Module         : Show Create and Modify detailin master page   #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Thursday, August 26th 2021, 12:12:49 pm       #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import React, { useState } from "react"
import { Row, Label,Col } from "reactstrap"

const DPInfoBox = ({createdBy,createdOn,modifiedBy,modifiedOn})=>{
    return(
        <div style={{height:"100px",width:"300px",padding:"5px",fontSize:"10px"}}>
            <hr/>
            <Row>
                <Col>
                    <Row>
                        <Col>
                            Created by :
                        </Col>
                        <Col>
                            {createdBy}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            Created on :
                        </Col>
                        <Col>
                            {createdOn}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            Last modified by :
                        </Col>
                        <Col>
                            {modifiedBy}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            Last modified on :
                        </Col>
                        <Col>
                            {modifiedOn}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
}

export default DPInfoBox;